/* eslint-disable react/prop-types */

import { createContext, useState } from "react";

const AdministrarContext = createContext();

export { AdministrarContext };
